(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

(function () {


  var header =
    document.querySelector('[data-header]');


  if (!header) return;


  /* ==========================================================
     SCROLL BEHAVIOR
     ========================================================== */

  var lastScrollTop =
    window.scrollY;

  var ticking =
    false;

  var scrollThreshold =
    40;


  function handleScroll() {

    var currentScrollTop =
      window.scrollY;


    if (
      currentScrollTop <=
      scrollThreshold
    ) {

      header.classList.remove(
        'is-hidden'
      );

      header.classList.remove(
        'is-compact'
      );

      header.classList.remove(
        'is-mega-open'
      );

      closeBestsellersMenu(true);

      header.classList.remove(
        'is-bestsellers-open'
      );

      lastScrollTop =
        currentScrollTop;

      return;

    }


    if (
      currentScrollTop >
      lastScrollTop
    ) {

      header.classList.add(
        'is-hidden'
      );

      header.classList.remove(
        'is-mega-open'
      );

      header.classList.remove(
        'is-bestsellers-open'
      );

    }


    else if (
      currentScrollTop <
      lastScrollTop
    ) {

      header.classList.remove(
        'is-hidden'
      );

      header.classList.add(
        'is-compact'
      );

    }


    lastScrollTop =
      currentScrollTop;

  }


  window.addEventListener(
    'scroll',
    function () {

      if (!ticking) {

        window.requestAnimationFrame(
          function () {

            handleScroll();

            ticking =
              false;

          }
        );

        ticking =
          true;

      }

    },
    {
      passive: true
    }
  );


  /* ==========================================================
     SHOP MEGA MENU
     ========================================================== */

  var shopTriggers =
    header.querySelectorAll(
      '[data-shop-trigger]'
    );


  var megaMenu =
    header.querySelector(
      '[data-shop-mega]'
    );


  var megaCloseTimer;


  function openMegaMenu() {

    if (
      window.innerWidth <= 749
    ) {

      return;

    }


    clearTimeout(
      megaCloseTimer
    );


    header.classList.add(
      'is-mega-open'
    );

    header.classList.remove(
      'is-bestsellers-open'
    );

  }


  function closeMegaMenu() {

    megaCloseTimer =
      setTimeout(
        function () {

          if (
            !header.matches(':hover')
          ) {

            header.classList.remove(
              'is-mega-open'
            );

          }

        },
        100
      );

  }


  shopTriggers.forEach(
    function (trigger) {

      trigger.addEventListener(
        'mouseenter',
        openMegaMenu
      );


      trigger.addEventListener(
        'mouseleave',
        closeMegaMenu
      );

    }
  );


  if (megaMenu) {

    megaMenu.addEventListener(
      'mouseenter',
      function () {

        clearTimeout(
          megaCloseTimer
        );

        header.classList.add(
          'is-mega-open'
        );

      }
    );


    megaMenu.addEventListener(
      'mouseleave',
      function () {

        header.classList.remove(
          'is-mega-open'
        );

        closeBestsellersMenu(true);

      }
    );

  }


  /* ==========================================================
     BESTSELLERS CAROUSEL MEGA MENU
     ========================================================== */

  var bestsellersTriggers =
    header.querySelectorAll('[data-bestsellers-trigger]');

  var bestsellersMenu =
    header.querySelector('[data-bestsellers-mega]');

  var bestsellersCloseTimer;
  var bestsellersAutoplayTimer;
  var bestsellersIndex = 0;

  function getBestsellersColumns() {
    if (!bestsellersMenu) return 1;
    return Math.max(1, parseInt(bestsellersMenu.dataset.productsDesktop || '5', 10));
  }

  function getBestsellersElements() {
    if (!bestsellersMenu) return {};
    return {
      viewport: bestsellersMenu.querySelector('[data-bestsellers-viewport]'),
      track: bestsellersMenu.querySelector('[data-bestsellers-track]'),
      slides: bestsellersMenu.querySelectorAll('[data-bestsellers-slide]'),
      prev: bestsellersMenu.querySelector('[data-bestsellers-prev]'),
      next: bestsellersMenu.querySelector('[data-bestsellers-next]')
    };
  }

  function updateBestsellersCarousel() {
    var parts = getBestsellersElements();
    if (!parts.track || !parts.slides || !parts.slides.length) return;

    var columns = getBestsellersColumns();
    var maxIndex = Math.max(0, parts.slides.length - columns);
    bestsellersIndex = Math.max(0, Math.min(bestsellersIndex, maxIndex));

    bestsellersMenu.style.setProperty('--bestsellers-columns', columns);
    bestsellersMenu.style.setProperty('--bestsellers-gap-total', ((columns - 1) * 22) + 'px');

    var firstSlide = parts.slides[0];
    var trackGap = parseFloat(window.getComputedStyle(parts.track).gap) || 0;
    var step = firstSlide.getBoundingClientRect().width + trackGap;
    parts.track.style.transform = 'translate3d(' + (-bestsellersIndex * step) + 'px, 0, 0)';

    if (parts.prev) parts.prev.disabled = bestsellersIndex === 0;
    if (parts.next) parts.next.disabled = bestsellersIndex >= maxIndex;
  }

  function moveBestsellers(direction) {
    var parts = getBestsellersElements();
    if (!parts.slides || !parts.slides.length) return;

    var maxIndex = Math.max(0, parts.slides.length - getBestsellersColumns());
    bestsellersIndex += direction;

    if (bestsellersIndex > maxIndex) bestsellersIndex = 0;
    if (bestsellersIndex < 0) bestsellersIndex = maxIndex;

    updateBestsellersCarousel();
  }

  function stopBestsellersAutoplay() {
    window.clearInterval(bestsellersAutoplayTimer);
    bestsellersAutoplayTimer = null;
  }

  function startBestsellersAutoplay() {
    stopBestsellersAutoplay();
    if (!bestsellersMenu || bestsellersMenu.dataset.autoplay !== 'true') return;

    var speed = Math.max(1000, parseInt(bestsellersMenu.dataset.speed || '4000', 10));
    bestsellersAutoplayTimer = window.setInterval(function () {
      moveBestsellers(1);
    }, speed);
  }

  function openBestsellersMenu() {
    if (window.innerWidth <= 749 || !bestsellersMenu) return;

    window.clearTimeout(bestsellersCloseTimer);
    header.classList.remove('is-mega-open');
    header.classList.add('is-bestsellers-open');
    bestsellersMenu.setAttribute('aria-hidden', 'false');
    bestsellersTriggers.forEach(function (trigger) {
      var link = trigger.querySelector('a');
      if (link) link.setAttribute('aria-expanded', 'true');
    });

    window.requestAnimationFrame(function () {
      updateBestsellersCarousel();
      startBestsellersAutoplay();
    });
  }

  function closeBestsellersMenu(immediate) {
    var close = function () {
      header.classList.remove('is-bestsellers-open');
      stopBestsellersAutoplay();

      if (bestsellersMenu) bestsellersMenu.setAttribute('aria-hidden', 'true');
      bestsellersTriggers.forEach(function (trigger) {
        var link = trigger.querySelector('a');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    };

    window.clearTimeout(bestsellersCloseTimer);
    if (immediate) close();
    else bestsellersCloseTimer = window.setTimeout(close, 120);
  }

  bestsellersTriggers.forEach(function (trigger) {
    trigger.addEventListener('mouseenter', openBestsellersMenu);
    trigger.addEventListener('mouseleave', function () {
      bestsellersCloseTimer = window.setTimeout(function () {
        if (!bestsellersMenu || !bestsellersMenu.matches(':hover')) {
          closeBestsellersMenu(true);
        }
      }, 120);
    });
  });

  if (bestsellersMenu) {
    var bestsellersParts = getBestsellersElements();

    bestsellersMenu.addEventListener('mouseenter', function () {
      window.clearTimeout(bestsellersCloseTimer);
      startBestsellersAutoplay();
    });

    bestsellersMenu.addEventListener('mouseleave', function () {
      closeBestsellersMenu(true);
    });

    if (bestsellersParts.prev) {
      bestsellersParts.prev.addEventListener('click', function () {
        moveBestsellers(-1);
        startBestsellersAutoplay();
      });
    }

    if (bestsellersParts.next) {
      bestsellersParts.next.addEventListener('click', function () {
        moveBestsellers(1);
        startBestsellersAutoplay();
      });
    }

    bestsellersMenu.addEventListener('focusin', function () {
      stopBestsellersAutoplay();
    });

    bestsellersMenu.addEventListener('focusout', function () {
      startBestsellersAutoplay();
    });
  }


  /* ==========================================================
     MOBILE MENU
     ========================================================== */

  var toggles =
    header.querySelectorAll(
      '[data-menu-toggle]'
    );


  var overlay =
    header.querySelector(
      '[data-menu-overlay]'
    );


  var drawer =
    header.querySelector(
      '[data-menu-drawer]'
    );


  function openMenu() {

    if (!drawer || !overlay) return;


    drawer.classList.add(
      'is-open'
    );


    overlay.classList.add(
      'is-open'
    );


    document.body.classList.add(
      'site-header-locked'
    );


    toggles.forEach(
      function (t) {

        t.setAttribute(
          'aria-expanded',
          'true'
        );

      }
    );

  }


  function closeMenu() {

    if (!drawer || !overlay) return;


    drawer.classList.remove(
      'is-open'
    );


    overlay.classList.remove(
      'is-open'
    );


    document.body.classList.remove(
      'site-header-locked'
    );


    toggles.forEach(
      function (t) {

        t.setAttribute(
          'aria-expanded',
          'false'
        );

      }
    );

  }


  toggles.forEach(
    function (btn) {

      btn.addEventListener(
        'click',
        function () {

          if (
            drawer.classList.contains(
              'is-open'
            )
          ) {

            closeMenu();

          }

          else {

            openMenu();

          }

        }
      );

    }
  );


  if (overlay) {

    overlay.addEventListener(
      'click',
      closeMenu
    );

  }


  /* ==========================================================
     LIVE PRODUCT SEARCH SUGGESTIONS
     ========================================================== */

  var predictiveSearchForms =
    header.querySelectorAll(
      '[data-predictive-search]'
    );


  var shopifyRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';


  var predictiveSearchUrl =
    shopifyRoot + 'search/suggest.json';


  function closeSearchSuggestions(form) {

    var suggestions =
      form.querySelector(
        '[data-search-suggestions]'
      );


    if (!suggestions) return;


    suggestions.hidden = true;

    suggestions.innerHTML = '';

  }


  function renderSearchSuggestions(form, products) {

    var suggestions =
      form.querySelector(
        '[data-search-suggestions]'
      );


    if (!suggestions) return;


    suggestions.innerHTML = '';


    if (!products.length) {

      var empty = document.createElement('p');

      empty.className =
        'site-header__suggestion-empty';

      empty.textContent = 'No products found';

      suggestions.appendChild(empty);

      suggestions.hidden = false;

      return;

    }


    products.forEach(function (product) {

      var link = document.createElement('a');

      link.className = 'site-header__suggestion';

      link.href = product.url;


      if (
        product.featured_image &&
        product.featured_image.url
      ) {

        var image = document.createElement('img');

        image.className =
          'site-header__suggestion-image';

        image.src = product.featured_image.url;

        image.alt = product.title;

        image.width = 58;

        image.height = 58;

        image.loading = 'lazy';

        link.appendChild(image);

      }


      var details = document.createElement('span');

      var title = document.createElement('span');

      title.className =
        'site-header__suggestion-title';

      title.textContent = product.title;

      details.appendChild(title);


      var sellingPriceValue = parsePriceValue(product.price);

      var comparePriceValue = parsePriceValue(product.compare_at_price);


      if (sellingPriceValue !== null) {

        var prices = document.createElement('span');

        prices.className = 'site-header__suggestion-prices';


        if (
          comparePriceValue !== null &&
          comparePriceValue > sellingPriceValue
        ) {

          var comparePrice = document.createElement('span');

          comparePrice.className =
            'site-header__suggestion-compare-price';

          comparePrice.textContent = formatINR(comparePriceValue);

          prices.appendChild(comparePrice);

        }


        var sellingPrice = document.createElement('span');

        sellingPrice.className =
          'site-header__suggestion-selling-price';

        sellingPrice.textContent = formatINR(sellingPriceValue);

        prices.appendChild(sellingPrice);

        details.appendChild(prices);

      }


      link.appendChild(details);

      suggestions.appendChild(link);

    });


    suggestions.hidden = false;

  }


  function parsePriceValue(value) {

    if (value === null || value === undefined || value === '') {

      return null;

    }


    if (typeof value === 'number') {

      return Number.isFinite(value) ? value : null;

    }


    var parsed = Number(
      String(value)
        .replace(/,/g, '')
        .replace(/[^0-9.-]/g, '')
    );

    return Number.isFinite(parsed) ? parsed : null;

  }


  function formatINR(value) {

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value);

  }


  predictiveSearchForms.forEach(function (form) {

    var input = form.querySelector('input[name="q"]');

    var searchTimer;

    var requestController;


    if (!input) return;


    input.addEventListener('input', function () {

      var query = input.value.trim();


      window.clearTimeout(searchTimer);


      if (requestController) {

        requestController.abort();

      }


      if (query.length < 1) {

        closeSearchSuggestions(form);

        return;

      }


      searchTimer = window.setTimeout(function () {

        requestController = new AbortController();


        fetch(
          predictiveSearchUrl +
          '?q=' + encodeURIComponent(query) +
          '&resources[type]=product' +
          '&resources[limit]=6',
          {
            signal: requestController.signal,
            headers: {
              'Accept': 'application/json'
            }
          }
        )
          .then(function (response) {

            if (!response.ok) {

              throw new Error('Search request failed');

            }


            return response.json();

          })
          .then(function (data) {

            var products =
              data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products
                ? data.resources.results.products
                : [];


            renderSearchSuggestions(form, products);

          })
          .catch(function (error) {

            if (error.name !== 'AbortError') {

              closeSearchSuggestions(form);

            }

          });

      }, 250);

    });


    input.addEventListener('focus', function () {

      if (input.value.trim().length >= 1) {

        input.dispatchEvent(new Event('input'));

      }

    });

  });


  document.addEventListener('click', function (event) {

    predictiveSearchForms.forEach(function (form) {

      if (!form.contains(event.target)) {

        closeSearchSuggestions(form);

      }

    });

  });


  /* ==========================================================
     MOBILE SEARCH
     ========================================================== */

  var searchToggles =
    header.querySelectorAll(
      '[data-search-toggle]'
    );


  var searchMobile =
    header.querySelector(
      '[data-search-mobile]'
    );


  searchToggles.forEach(
    function (btn) {

      btn.addEventListener(
        'click',
        function () {

          if (!searchMobile) return;


          searchMobile.classList.toggle(
            'is-open'
          );


          if (
            searchMobile.classList.contains(
              'is-open'
            )
          ) {

            var input =
              searchMobile.querySelector(
                'input[name="q"]'
              );


            if (input) {

              input.focus();

            }

          }

        }
      );

    }
  );


  /* ==========================================================
     RESIZE
     ========================================================== */

  window.addEventListener(
    'resize',
    function () {

      if (
        window.innerWidth <= 749
      ) {

        header.classList.remove(
          'is-mega-open'
        );

      }


      if (
        window.innerWidth > 749
      ) {

        closeMenu();


        if (searchMobile) {

          searchMobile.classList.remove(
            'is-open'
          );

        }

        updateBestsellersCarousel();

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();
})();
